var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42941",
    "data-name": "Group 42941",
    transform: "translate(6218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16010",
    "data-name": "Rectangle 16010",
    width: 16,
    height: 16,
    transform: "translate(-6218)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pause_2_",
    "data-name": "pause (2)",
    transform: "translate(-6214.935 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37210",
    "data-name": "Path 37210",
    d: "M13.8,18a1.534,1.534,0,0,0,1.532-1.532V5.532a1.532,1.532,0,1,0-3.064,0V16.468A1.534,1.534,0,0,0,13.8,18Z",
    transform: "translate(-12.264 -4)",
    fill: "#868d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37211",
    "data-name": "Path 37211",
    d: "M42.545,16.468V5.532a1.532,1.532,0,1,0-3.064,0V16.468a1.532,1.532,0,1,0,3.064,0Z",
    transform: "translate(-32.677 -4)",
    fill: "#868d97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.7bd2c366e96bf08087e722475d8f6ce2.svg";
export { ForwardRef as ReactComponent };